import React, { useContext, useState, useCallback, useEffect } from "react";
import "./Navigation.scss";
import Masks from "../../../components/VectorIcons/Masks";
import Microphone from "../../../components/VectorIcons/Microphone";
import ChannelContext from "../../../context/externalProjectsContext";
import { returnFictionAndNotFictionLabel } from "../../../shared/utils/returnFictionAndNotFictionLabel";
import { EXTERNAL_PROJECTS_TAB_TYPES } from "../../../shared/constants/externalProjectsTabs";

const DEFAULT_TAB = "Todos";

const Navigation = (props) => {
  const { countsByType } = props;

  const [stateCurrentTypeId, setCurrentTypeId] = useState(DEFAULT_TAB);
  const channelContext = useContext(ChannelContext);

  const setFilter = (type) => {
    channelContext.setCurrentTypeSearchType(type);
    setCurrentTypeId(type);
  };

  const updateFilter = useCallback(() => {
    channelContext.setFilter({
      pageNumber: 1,
      Limit: 12,
    });
  }, [channelContext]);

  const returnTypeIcon = (tabType) => {
    const types = {
      Todos: <></>,
      Dramaturgia: (
        <Masks
          color={stateCurrentTypeId === "Dramaturgia" ? "#ffffff" : "#adafef"}
        />
      ),
      Variedades: (
        <Microphone
          color={stateCurrentTypeId === "Variedades" ? "#ffffff" : "#adafef"}
        />
      ),
    };
    return types[tabType];
  };

  useEffect(() => {
    let done = false;
    if (done) updateFilter();
    return () => {
      done = true;
    };
  }, [updateFilter]);

  useEffect(() => {
    setCurrentTypeId(DEFAULT_TAB);
  }, [countsByType]);

  const tabs = Object.entries(EXTERNAL_PROJECTS_TAB_TYPES).map(
    ([type, contentTypes]) => ({
      type,
      count: countsByType
        .filter((item) => contentTypes.includes(item.type))
        .reduce((total, item) => total + item.count, 0),
    })
  );

  return (
    <div id="Navigation">
      <div className="container">
        {tabs.map(({ type, count }) => {
          return (
            <div
              key={type}
              className={`itemNavigation ${
                stateCurrentTypeId === type ? "active" : ""
              }`}
              onClick={() => setFilter(type)}
            >
              {returnTypeIcon(type)}
              <span>{returnFictionAndNotFictionLabel(type)}</span>
              <span className="counter">{count ? ` (${count})` : ""}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Navigation;
